var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"wh-icon",style:(_vm.sizeStyle),attrs:{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":_vm.strokeWidth,"stroke-linecap":"round","stroke-linejoin":"round"},domProps:{"innerHTML":_vm._s(_vm.path)}})
}
var staticRenderFns = []

export { render, staticRenderFns }